import type { RequestConfig } from '@customTypes/index';
import type { DayScheduleItem } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type PostClubProfileScheduleRequest = {
  clubId: string;
  data: DayScheduleItem[];
};

export type PostClubProfileScheduleParams =
  RequestConfig<PostClubProfileScheduleRequest>;

export const postClubProfileSchedule = async ({
  params,
  config
}: PostClubProfileScheduleParams) =>
  api.post(`/api/ClubProfile/schedule/${params.clubId}`, params.data, config);
